module.exports = require('./lib')


/** WEBPACK FOOTER **
 ** ../biro-material-ui/index.js
 **/